import React, { useEffect, useState } from 'react';
import { GameCardVM } from '@/models/vm/game-card-vm.model';
import { GamesCategories } from '@/models/game-category.type';
import GamesSkeletonLoader from '@/components/shared/skeleton-loader/GamesSkeletonLoader';
import GamesSingleStreamline from '@/components/shared/games/GamesSingleStreamline';
import InViewSection from '@/components/shared/in-view-section/InViewSection';
import GamesDoubleStreamline from '@/components/shared/games/GamesDoubleStreamline';
import GamesMasonryStreamline from '@/components/shared/games/GamesMasonryStreamline';
import GamesLargeStreamline from '@/components/shared/games/GamesLargeStreamline';

export enum GamesStreamlineType {
  Single,
  Double,
  Masonry,
  Large,
}
export type GamesStreamlineSectionCommonProps = {
  games: GameCardVM[];
  category: GamesCategories | string;
};

export type GamesStreamlineSectionProps = GamesStreamlineSectionCommonProps & {
  type: GamesStreamlineType;
  loading: boolean;
  visibleGames: number;
};

export interface GamesStreamlineTypeProp {
  type: GamesStreamlineType;
}

const GamesStreamlineSectionMap: Record<
  GamesStreamlineType,
  React.FC<GamesStreamlineSectionCommonProps>
> = {
  [GamesStreamlineType.Single]: GamesSingleStreamline,
  [GamesStreamlineType.Double]: GamesDoubleStreamline,
  [GamesStreamlineType.Masonry]: GamesMasonryStreamline,
  [GamesStreamlineType.Large]: GamesLargeStreamline,
};

function GamesStreamlineSection({
  type,
  loading,
  games,
  visibleGames,
  category,
}: GamesStreamlineSectionProps): JSX.Element | null {
  const [items, setItems] = useState<GameCardVM[]>([]);
  const Section = GamesStreamlineSectionMap[type];

  useEffect(() => {
    setItems(games.slice(0, Math.min(visibleGames, games.length)));
  }, [games, visibleGames]);

  if (loading) {
    return <GamesSkeletonLoader />;
  }

  if (!loading && (!games || games.length === 0)) {
    // we don't want to show anything if there are no games
    return null;
  }

  return (
    <InViewSection loader={<GamesSkeletonLoader />}>
      <Section games={items} category={category} />
    </InViewSection>
  );
}

export default GamesStreamlineSection;
